import { action } from '@ember/object';
import Component from '@glimmer/component';
import type EmployeeModel from 'garaje/models/employee';

interface EmployeesDirectoryTableLayoutArgs {
  isLoadingAll: boolean;
  noResultsFound: boolean;
  pageCount: number;
  pageNumber: number;
  pageSize: number;
  recordCount: number;
  setPageNumber: (pageNumber: number) => void;
  columns: Array<string>;
  employees: Array<EmployeeModel>;
  routeToEmployeeEdit: (employeeId: string) => void;
  defaultLocationName: (defaultLocationId: string) => void;
  displayAssistants: (assistants: Array<EmployeeModel>) => string;
  sortDirection: string;
  changeSortDirection: (sortField: string, sortDirection: string) => void;
  hideEmployeeContactDetails: boolean;
}

export default class EmployeesDirectoryTableLayoutComponent extends Component<EmployeesDirectoryTableLayoutArgs> {
  @action
  hideColumn(column: string): boolean {
    const hiddenColumns = ['Phone number'];
    return this.args.hideEmployeeContactDetails && hiddenColumns.includes(column);
  }
}
